import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./bowscorecard.css";

function ScoreboardBowling() {
  const matchId = localStorage.getItem("match_id");
  const navigate = useNavigate();
  const scoreRef = useRef();

  const [bowling, setBowling] = useState([]);
  const [matchSummary, setMatchSummary] = useState({});

  useEffect(() => {
    fetch(`https://nammateam.onrender.com/bowlingstats/${matchId}`)
      .then(res => res.json())
      .then(data => { if (data.success) setBowling(data.bowlers); });

    fetch(`https://nammateam.onrender.com/match/summary/${matchId}`)
      .then(res => res.json())
      .then(data => { if (data.success) setMatchSummary(data); });
  }, [matchId]);

  const ballsToOvers = (balls) => {
    const completeOvers = Math.floor(balls / 6);
    const remainingBalls = balls % 6;
    return `${completeOvers}.${remainingBalls}`;
  };

  const totals = bowling.reduce(
    (acc, b) => {
      acc.balls += b.balls_bowled;
      acc.maidens += b.maidens;
      acc.runs += b.runs_given;
      acc.wickets += b.wickets;
      return acc;
    },
    { balls: 0, maidens: 0, runs: 0, wickets: 0 }
  );

  return (
    <div className="fsc-container">
      <div className="fsc-header">
        <button className="fsc-back" onClick={() => navigate("/live")}>← Back</button>
        <h2>Bowling Scorecard</h2>
      </div>

      <div ref={scoreRef} className="fsc-content">
        <div className="fsc-match-title">
          <h3>{matchSummary.team2 || "Team 2"} Bowling</h3>
          <p>{matchSummary.result || ""}</p>
        </div>

        <div className="fsc-section">
          <table className="fsc-table">
            <thead>
              <tr>
                <th>Bowler</th>
                <th>O</th>
                <th>M</th>
                <th>R</th>
                <th>W</th>
                <th>Econ</th>
              </tr>
            </thead>
            <tbody>
              {bowling.map((b, i) => (
                <tr key={i}>
                  <td>{b.bowler_name}</td>
                  <td>{ballsToOvers(b.balls_bowled)}</td>
                  <td>{b.maidens}</td>
                  <td>{b.runs_given}</td>
                  <td>{b.wickets}</td>
                  <td>{b.economy.toFixed(2)}</td>
                </tr>
              ))}
              {bowling.length > 0 && (
                <tr className="fsc-total-row">
                  <td>Total</td>
                  <td>{ballsToOvers(totals.balls)}</td>
                  <td>{totals.maidens}</td>
                  <td>{totals.runs}</td>
                  <td>{totals.wickets}</td>
                  <td>{totals.balls > 0 ? (totals.runs / (totals.balls / 6)).toFixed(2) : 0}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ScoreboardBowling;
